import React from "react";

import { ListStyled } from "../../theme";
import { getTranslation } from "../languageProvider";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { DateTimeFormatTimezone } from "../shared/utility";

export const RoutesDetail = ({
  route,
  isActive,
  Select,
  Edit,
  Delete,
  Disable,
  EditTechnician,
  EditEquipment,
  EditDocument,
}) => {
  const editHandler = () => Edit && Edit(route);
  const selectHandler = () => Select && Select(route);
  const deleteHandler = () => Delete && Delete(route.id);
  const editTechnicianHandler = () => EditTechnician && EditTechnician(route);
  const editEquipmentHandler = () => EditEquipment && EditEquipment(route);
  const editDocumentHandler = () => EditDocument && EditDocument(route);

  return (
    <ListStyled isActive={isActive} route>
      <div className="detail" onClick={selectHandler}>
        {route.name}
        <span>{route.observations}</span>
        <span data-translate="0028,0029">
          <b data-translate="0026">{getTranslation("0026")}:</b>
          {route.started
            ? DateTimeFormatTimezone(route.started)
            : getTranslation("0029")}
          , <b data-translate="0026">{getTranslation("0027")}:</b>
          {route.ended
            ? DateTimeFormatTimezone(route.ended)
            : route.started
            ? getTranslation("0028")
            : getTranslation("0029")}
        </span>
      </div>

      {Edit && (
        <span className="add" onClick={editHandler}>
          <EditOutlinedIcon />
        </span>
      )}
      {EditEquipment && (
        <span className={"add"} onClick={editEquipmentHandler}>
          <DevicesOutlinedIcon />
        </span>
      )}
      {EditTechnician && (
        <span className="add" onClick={editTechnicianHandler}>
          <SupervisorAccountIcon />
        </span>
      )}
      {EditDocument && (
        <span className="add" onClick={editDocumentHandler}>
          <PictureAsPdfIcon />
        </span>
      )}
      {Delete && (
        <span
          className={route.started ? "disable" : "delete"}
          onClick={route.started ? Disable : deleteHandler}
        >
          <DeleteOutlineOutlinedIcon />
        </span>
      )}
    </ListStyled>
  );
};
